import React from "react";
import NotifySuccess from "./NotifySuccess";
import NotifyError from "./NotifyError";
import NotifyWarn from "./NotifyWarn";
import ClearClose from "./ClearClose";
import TriangleDown from "./TriangleDown";
import Love from "./Love";
import LoveFill from "./LoveFill";
import Share from "./Share";
import ShareFill from "./ShareFill";
import Link from "./Link";
interface Props {
  name: string;
  // className?: string;
  color?: string;
  size?: number;
}

const Icon: React.FC<Props> = ({ name, color, size }: Props) => {
  const svgIcons = {
    "notify-success": <NotifySuccess width={`${size}`} />,
    "notify-error": <NotifyError width={`${size}`} />,
    "notify-warn": <NotifyWarn width={`${size}`} />,
    "clear-close": <ClearClose width={`${size}`} />,
    "triangle-down": <TriangleDown width={`${size}`} color={color} />,
    love: <Love width={`${size}`} color={color} />,
    "love-fill": <LoveFill width={`${size}`} color={color} />,
    share: <Share width={`${size}`} color={color} />,
    "share-fill": <ShareFill width={`${size}`} color={color} />,
    link: <Link width={`${size}`} color={color} />,
  };
  return <>{svgIcons[name]}</>;
};

Icon.defaultProps = {
  size: 16,
};

export default Icon;
